<div
  class="z-card-wrapper z-fx-col z-fx-auto"
  [style.maxHeight]="maxHeight | async"
  [style.minHeight.px]="(ss.playerDimensions | async).height"
>
  <div class="z-card-before" [class.z-hidden]="first" [style.background-color]="(ss.colors | async)?.moodOpacity"></div>
  <ng-content></ng-content>
  <div class="z-card-after" [class.z-hidden]="last" [style.background-color]="(ss.colors | async)?.moodOpacity"></div>
</div>
